import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8180667c")

_pushScopeId("data-v-8180667c")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "grid-content aside-bg back-image",
  style: {"background-color":"#fff"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_row, null, {
      default: _withId(() => [
        _createVNode(_component_el_col, {
          xs: 0,
          sm: 14,
          md: 14,
          lg: 16,
          xl: 16
        }, {
          default: _withId(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 10,
          md: 10,
          lg: 8,
          xl: 8
        }, {
          default: _withId(() => [
            _createVNode(_component_LoginForm)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})